// extracted by mini-css-extract-plugin
module.exports = {"container":"frameVisiblePicker_container__clfk6","button":"frameVisiblePicker_button___QBiI"};